"use client"

import { useUIBuilderLocaleStore } from "@/(admin)/modules/ui-builder/store/useUIBuilderLocaleStore"
import { ComponentConfig } from "@measured/puck"
import { useParams } from "next/navigation"
import { useEffect, useState } from "react"
import { twMerge } from "tailwind-merge"
import { useWebsiteDomainStore } from "../../../components/WebsiteSelect"
import LatestNewsContent from "./components/LatestNewsContent"
import { useLatestNews } from "./hooks/useLatestNews"
import { LatestNewsProps } from "./types"

const LATEST_NEWS_PAGE_SIZE = 5

export const RenderConfig: ComponentConfig<LatestNewsProps> = {
    render: ({ websiteDomain: initialWebsiteDomain, className, title, puck }) => {
        const params = useParams()
        const storeLocale = useUIBuilderLocaleStore(state => state.locale)
        const [currentPage, setCurrentPage] = useState(1)
        // params.locale phải đứng trước: storeLocale mặc định "vi" (luôn truthy) nên nếu
        // để trước nó sẽ nuốt locale của URL và khoá block ở tiếng Việt trên site public.
        const currentLocale = (params?.locale as string) || storeLocale || "vi"
        const storeDomain = useWebsiteDomainStore((state: { websiteDomain: string }) => state.websiteDomain)
        // useWebsiteDomainStore là store in-memory (không persist cookie) và chỉ được
        // set bởi field WebsiteSelect trong editor, nên trên public nó luôn "" -> đọc
        // đúng initialWebsiteDomain đã lưu. Vẫn gate theo puck.isEditing cho nhất quán
        // với PostGridByCategory và phòng khi store bị set/persist ở nơi khác về sau.
        const effectiveDomain = (puck?.isEditing ? storeDomain : "") || initialWebsiteDomain

        // LatestNewsContent renders exactly 5 articles (1 featured + 1 sidebar + 3 grid),
        // so the page size has to match or the pagination count is off by 2x.
        const { articles, loading, error, totalPages } = useLatestNews({
            page: currentPage,
            pageSize: LATEST_NEWS_PAGE_SIZE,
            locale: currentLocale || "vi",
            domain: effectiveDomain,
        })

        useEffect(() => {
            setCurrentPage(1)
        }, [effectiveDomain, currentLocale])

        const handlePageChange = (page: number) => {
            setCurrentPage(page)
            window.scrollTo({ top: 0, behavior: "smooth" })
        }

        return (
            <div className={twMerge("w-full max-w-[1304px] mx-auto px-4 sm:pt-[80px] pt-[62px] pb-[94px]", className)}>
                <LatestNewsContent
                    articles={articles}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    loading={loading}
                    title={title}
                />
            </div>
        )
    },
}
